// Patch 23: 9 avatars (01-03 girls, 04-06 boys, 07-09 cats), framed for the circle. ?v busts the old images.
const AVATAR_RE = /^avatar-(0[1-9]|1[3-5])$/;
export const avatarSrc = (a) => `/avatars/${a}.png?v=24`;

const RING = {
  1: { color: "#D4A82C", glow: "rgba(212,168,44,0.55)" }, // gold
  2: { color: "#C9CDD3", glow: "rgba(201,205,211,0.45)" }, // silver
  3: { color: "#B46A1A", glow: "rgba(180,106,26,0.5)" }, // bronze
};

export default function UserAvatar({ avatar, name, size = 32, className = "", testId, rank = 0 }) {
  const dim = { width: size, height: size };
  const ring = RING[rank];
  const ringStyle = ring
    ? { boxShadow: `0 0 0 2px ${ring.color}, 0 0 10px -1px ${ring.glow}` }
    : undefined;

  if (avatar && AVATAR_RE.test(avatar)) {
    return (
      <span
        data-testid={testId}
        style={{ ...dim, ...ringStyle }}
        className={`relative inline-block rounded-full overflow-hidden bg-[#0f0f13] ${ring ? "" : "border border-amber-500/25"} shrink-0 ${className}`}
      >
        <img
          src={avatarSrc(avatar)}
          alt={name || "avatar"}
          className="w-full h-full object-cover"
          style={{ imageRendering: "pixelated" }}
        />
      </span>
    );
  }
  const initial = (name || "?").trim().charAt(0).toUpperCase();
  return (
    <div
      aria-hidden
      data-testid={testId}
      style={{ ...dim, ...ringStyle }}
      className={`rounded-full bg-gradient-to-br from-amber-500/30 to-amber-700/10 ${ring ? "" : "border border-amber-400/40"} flex items-center justify-center font-display font-black text-amber-300 shrink-0 ${className}`}
    >
      <span style={{ fontSize: Math.round(size * 0.45), lineHeight: 1 }}>{initial}</span>
    </div>
  );
}
